/**
 * The two presentations of Impact pages: pinned pages (case studies) as
 * lines, the rest as a card grid.
 */
import React from "react";
import PropTypes from "prop-types";
import { Reveal } from "../../ui/motion";
import { ImpactCard, ImpactLine } from "../../ui/cards";

/** Case studies as stacked lines that reveal one after another. */
export const ImpactLines = ({ pages }) => (
	<div className="border-b border-pp-rule">
		{pages.map((entry, i) => (
			<Reveal key={entry.slug} delay={i * 60}>
				<ImpactLine entry={entry} index={i} />
			</Reveal>
		))}
	</div>
);

/**
 * Impact pages as a card grid. With `swipe`, phones get one horizontal,
 * snapping strip that bleeds to the screen edge (the next card peeks in,
 * inviting the swipe); from sm up it is the same grid as everywhere else.
 */
export const ImpactCards = ({ pages, swipe = false }) => (
	<div
		className={
			swipe
				? "flex gap-5 overflow-x-auto snap-x snap-mandatory scroll-px-6 -mx-6 px-6 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 sm:gap-x-8 sm:gap-y-14 sm:mx-0 sm:px-0 sm:overflow-visible sm:pb-0 items-stretch"
				: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14 items-stretch"
		}
	>
		{pages.map((entry, i) => (
			<Reveal
				key={entry.slug}
				delay={(i % 3) * 60}
				className={`h-full ${swipe ? "w-[82%] shrink-0 snap-start sm:w-auto" : ""}`}
			>
				<ImpactCard entry={entry} />
			</Reveal>
		))}
	</div>
);

ImpactLines.propTypes = { pages: PropTypes.arrayOf(PropTypes.object).isRequired };
ImpactCards.propTypes = {
	pages: PropTypes.arrayOf(PropTypes.object).isRequired,
	swipe: PropTypes.bool,
};
